import React, {useMemo, useState} from 'react'

const RecipeUpdateContext = React.createContext()
RecipeUpdateContext.displayName = 'RecipeUpdateContext'

const RecipeUpdateProvider = ({children}) => {
    const [recipeById, setRecipeById] = useState({})

    const calculateMaterialsSubTotal = () => {
        let total = 0

        if (recipeById.billOfMaterials) {
            recipeById.billOfMaterials.forEach((item, index) => {
                if (item.stock) {
                    total += item.amount * item.parity * item.unitPrice
                }
            })
        }

        return total
    }

    const productionCostsTotal = () => {
        let total = 0
        if (recipeById.recipeProductionCosts) {
            recipeById.recipeProductionCosts.map(costItem => total += costItem.ratio)
        }

        return total
    }

    const calcRecipeTotal = () => memoizedProductionCostsTotal + materialsSubtotal

    const materialsSubtotal = useMemo(() => calculateMaterialsSubTotal(), [recipeById])
    const memoizedProductionCostsTotal = useMemo(() => productionCostsTotal(), [recipeById])
    const updateRecipeTotal = useMemo(() => calcRecipeTotal(), [materialsSubtotal, memoizedProductionCostsTotal])


    const values = {
        byId: [recipeById, setRecipeById],
        subTotals: materialsSubtotal,
        productionTotalCost: memoizedProductionCostsTotal,
        recipeTotal: updateRecipeTotal
    }

    return (
        <RecipeUpdateContext.Provider value={values}>
            {children}
        </RecipeUpdateContext.Provider>
    )
}
export {RecipeUpdateContext, RecipeUpdateProvider}